import { createService } from './config/axios';
import {
  TScoreListParams,
  TScoreListResponse,
  TScoreDetailParams,
  TScoreDetailResponse,
  TScoreParams,
} from 'types/apis/score';
import qs from 'qs';

export const getScoreList = async (params: TScoreListParams) => {
  const queryString = qs.stringify(params);
  const url = `/professor-score-management?${queryString}`;

  return await createService<TScoreListResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

export const getScoreDetail = async (params: TScoreDetailParams) => {
  const queryString = qs.stringify(params);
  const url = `/professor-score-management/detail?${queryString}`;

  return await createService<TScoreDetailResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

export const postScore = async (data: TScoreParams) =>
  await createService({
    url: '/professor-score-management',
    options: {
      method: 'post',
      data,
    },
  });
